(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestsellers-product-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('bestsellers-product-rail')) return;

    const RESET_DELAY = 2000;
    const SOURCE = 'bestsellers-product-rail';

    /** @type {Promise<Record<string, any> | null> | null} */
    let eventsModule = null;

    /** Loads the theme's standard cart events through the import map; null when unavailable. */
    function loadEvents() {
      eventsModule ??= import('@shopify/events').catch(() => null);
      return eventsModule;
    }

    class CartAddError extends Error {
      /** @param {string} message */
      constructor(message) {
        super(message);
        this.name = 'CartAddError';
      }
    }

    class BestsellersProductRail extends HTMLElement {
      /** @type {AbortController | null} */
      #controller = null;
      /** @type {ResizeObserver | null} */
      #resizeObserver = null;
      #frame = 0;
      /** @type {Set<number>} */
      #timers = new Set();

      connectedCallback() {
        this.#controller = new AbortController();
        const { signal } = this.#controller;

        this.addEventListener('submit', this.#onSubmit, { signal });
        this.#prev?.addEventListener('click', () => this.#page(-1), { signal });
        this.#next?.addEventListener('click', () => this.#page(1), { signal });
        this.#rail?.addEventListener('scroll', this.#scheduleUpdate, { signal, passive: true });
        document.addEventListener('shopify:block:select', this.#onBlockSelect, { signal });

        if (this.#rail && 'ResizeObserver' in window) {
          this.#resizeObserver = new ResizeObserver(this.#scheduleUpdate);
          this.#resizeObserver.observe(this.#rail);
        }

        this.#updateArrows();
      }

      disconnectedCallback() {
        this.#controller?.abort();
        this.#controller = null;
        this.#resizeObserver?.disconnect();
        this.#resizeObserver = null;
        cancelAnimationFrame(this.#frame);
        for (const timer of this.#timers) clearTimeout(timer);
        this.#timers.clear();
      }

      get #rail() {
        return this.querySelector('[data-bs-rail]');
      }

      get #prev() {
        return this.querySelector('[data-bs-prev]');
      }

      get #next() {
        return this.querySelector('[data-bs-next]');
      }

      get #status() {
        return this.querySelector('[data-bs-status]');
      }

      #prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      /** @param {() => void} callback @param {number} delay */
      #later(callback, delay) {
        const timer = window.setTimeout(() => {
          this.#timers.delete(timer);
          callback();
        }, delay);
        this.#timers.add(timer);
      }

      #scheduleUpdate = () => {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(() => this.#updateArrows());
      };

      /** @param {number} direction 1 for next, -1 for previous */
      #page(direction) {
        const rail = this.#rail;
        if (!(rail instanceof HTMLElement)) return;

        const styles = getComputedStyle(rail);
        const inlinePadding = (parseFloat(styles.paddingInlineStart) || 0) + (parseFloat(styles.paddingInlineEnd) || 0);
        const step = rail.clientWidth - inlinePadding + (parseFloat(styles.columnGap) || 0);
        const sign = styles.direction === 'rtl' ? -1 : 1;

        rail.scrollBy({
          left: step * direction * sign,
          behavior: this.#prefersReducedMotion() ? 'auto' : 'smooth',
        });
      }

      #updateArrows() {
        const rail = this.#rail;
        const prev = this.#prev;
        const next = this.#next;
        if (!(rail instanceof HTMLElement)) return;

        const max = rail.scrollWidth - rail.clientWidth;
        const position = Math.abs(rail.scrollLeft);
        const overflowing = max > 1;
        this.toggleAttribute('data-overflowing', overflowing);

        if (!(prev instanceof HTMLButtonElement) || !(next instanceof HTMLButtonElement)) return;

        const atStart = !overflowing || position <= 1;
        const atEnd = !overflowing || position >= max - 1;

        // Keep keyboard focus on a usable control when the focused arrow becomes disabled.
        if (atStart && document.activeElement === prev && !atEnd) next.focus();
        if (atEnd && document.activeElement === next && !atStart) prev.focus();

        prev.disabled = atStart;
        next.disabled = atEnd;
      }

      /** @param {Event} event */
      #onBlockSelect = (event) => {
        const detail = /** @type {CustomEvent} */ (event).detail;
        if (!detail || detail.sectionId !== this.dataset.sectionId) return;

        const item = this.querySelector(`[data-block-id="${CSS.escape(String(detail.blockId))}"]`);
        if (!(item instanceof HTMLElement)) return;

        const rail = this.#rail;
        if (!(rail instanceof HTMLElement)) return;

        const railStart = parseFloat(getComputedStyle(rail).scrollPaddingInlineStart) || 0;
        rail.scrollTo({ left: item.offsetLeft - rail.offsetLeft - railStart, behavior: 'auto' });
      };

      /** @param {string} message */
      #announce(message) {
        const status = this.#status;
        if (!status) return;

        status.textContent = '';
        requestAnimationFrame(() => {
          status.textContent = message;
        });
        this.#later(() => {
          if (status.textContent === message) status.textContent = '';
        }, RESET_DELAY * 2);
      }

      /** @param {AbortSignal} signal */
      async #fetchCart(signal) {
        const response = await fetch(this.dataset.cartUrl || '/cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          signal,
        });
        if (!response.ok) throw new Error(`Failed to fetch cart: ${response.status}`);
        return response.json();
      }

      /** @param {SubmitEvent} event */
      #onSubmit = async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-bs-form')) return;

        event.preventDefault();
        if (form.dataset.busy === 'true' || !this.#controller) return;

        const button = form.querySelector('[data-bs-submit]');
        const label = button?.querySelector('[data-bs-label]');
        const errorEl = form.querySelector('[data-bs-error]');
        const formData = new FormData(form);
        const id = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity')) || 1;
        if (!id || !(button instanceof HTMLButtonElement)) return;

        const { signal } = this.#controller;
        /** @param {string | undefined} text */
        const setLabel = (text) => {
          if (label && text) label.textContent = text;
        };
        const restore = () => {
          delete form.dataset.busy;
          button.removeAttribute('aria-disabled');
          button.removeAttribute('aria-busy');
          setLabel(button.dataset.labelDefault);
        };

        form.dataset.busy = 'true';
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-busy', 'true');
        setLabel(button.dataset.labelAdding);
        if (errorEl instanceof HTMLElement) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }

        const events = await loadEvents();
        const UpdateEvent = events?.CartLinesUpdateEvent;
        const CartError = events?.CartErrorEvent;
        const deferred = typeof UpdateEvent?.createPromise === 'function' ? UpdateEvent.createPromise() : null;

        if (deferred) {
          this.dispatchEvent(
            new UpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(id), quantity }],
              promise: deferred.promise,
            })
          );
        }

        const sectionIds = [];
        for (const element of document.querySelectorAll('cart-items-component')) {
          if (element instanceof HTMLElement && element.dataset.sectionId) sectionIds.push(element.dataset.sectionId);
        }

        /** @param {any} cart @param {Record<string, any>} extra */
        const resolveWith = (cart, extra) => {
          deferred?.resolve({
            cart: UpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: SOURCE,
              sourceId: this.dataset.sectionId,
              itemCount: quantity,
              productId: form.dataset.productId,
              ...extra,
            },
          });
        };

        try {
          const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id, quantity }],
              ...(sectionIds.length ? { sections: sectionIds.join(',') } : {}),
            }),
            signal,
          });
          const result = await response.json().catch(() => ({}));

          if (!response.ok || result.status) {
            throw new CartAddError(result.description || result.message || this.dataset.errorMessage || '');
          }

          const cart = await this.#fetchCart(signal);
          resolveWith(cart, { sections: result.sections, didError: false });

          this.dispatchEvent(
            new CustomEvent('bestsellers:cart-add', {
              bubbles: true,
              detail: { variantId: id, quantity, cart, sectionId: this.dataset.sectionId },
            })
          );

          setLabel(button.dataset.labelAdded);
          button.removeAttribute('aria-busy');
          this.#announce(this.dataset.addedMessage || '');
          this.#later(restore, RESET_DELAY);
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            deferred?.reject(error);
            return;
          }

          const isServerError = error instanceof CartAddError;
          const message =
            (isServerError && error.message) || this.dataset.errorMessage || 'Error adding to cart';

          if (CartError) {
            this.dispatchEvent(
              new CartError({ error: message, code: isServerError ? 'INVALID' : 'SERVICE_UNAVAILABLE' })
            );
          }

          if (deferred) {
            if (isServerError) {
              try {
                resolveWith(await this.#fetchCart(signal), { didError: true });
              } catch (refreshError) {
                deferred.reject(refreshError);
              }
            } else {
              deferred.reject(error);
            }
          }

          if (errorEl instanceof HTMLElement) {
            errorEl.textContent = message;
            errorEl.hidden = false;
          }
          this.#announce(message);
          restore();
        }
      };
    }

    customElements.define('bestsellers-product-rail', BestsellersProductRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-product-accordion')) {
    /**
     * Toggles accordion items rendered by sections/custom-product-accordion.liquid.
     * Liquid renders the initial open state; this element only syncs the `is-open`
     * class and `aria-expanded`. CSS owns the animation, so rapid clicks reverse
     * smoothly. Lifecycle callbacks cover theme editor section load/unload.
     */
    class CustomProductAccordion extends HTMLElement {
      /** @type {AbortController | undefined} */
      #abortController;

      connectedCallback() {
        this.#abortController?.abort();
        this.#abortController = new AbortController();
        const { signal } = this.#abortController;

        this.addEventListener('click', this.handleClick, { signal });
        document.addEventListener('shopify:block:select', this.handleBlockSelect, { signal });
      }

      disconnectedCallback() {
        this.#abortController?.abort();
        this.#abortController = undefined;
      }

      /** @returns {HTMLElement[]} */
      get items() {
        return Array.from(this.querySelectorAll('.custom-product-accordion__item')).filter(
          (item) => item instanceof HTMLElement && item.closest('custom-product-accordion') === this
        );
      }

      /** @param {MouseEvent} event */
      handleClick = (event) => {
        if (!(event.target instanceof Element)) return;

        const trigger = event.target.closest('.custom-product-accordion__trigger');
        if (!(trigger instanceof HTMLButtonElement) || trigger.closest('custom-product-accordion') !== this) return;

        const item = trigger.closest('.custom-product-accordion__item');
        if (!(item instanceof HTMLElement)) return;

        this.setItemOpen(item, trigger.getAttribute('aria-expanded') !== 'true');
      };

      /** @param {Event} event Theme editor event dispatched on the selected block element. */
      handleBlockSelect = (event) => {
        if (!(event.target instanceof HTMLElement) || !this.contains(event.target)) return;

        const item = event.target.closest('.custom-product-accordion__item');
        if (item instanceof HTMLElement) this.setItemOpen(item, true);
      };

      /**
       * @param {HTMLElement} item
       * @param {boolean} open
       */
      setItemOpen(item, open) {
        const trigger = item.querySelector('.custom-product-accordion__trigger');
        if (!(trigger instanceof HTMLButtonElement)) return;

        if (open && this.dataset.openMode === 'single') {
          for (const other of this.items) {
            if (other !== item) this.setItemOpen(other, false);
          }
        }

        item.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', String(open));
      }
    }

    customElements.define('custom-product-accordion', CustomProductAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-fundamental-quick-actions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '.df-quick-actions__list';
    const DRAG_THRESHOLD = 4; // px of movement before a click is treated as a drag

    const init = (list) => {
      if (list.dataset.dragReady === 'true') return;
      list.dataset.dragReady = 'true';

      let isDown = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;

      const onPointerMove = (event) => {
        if (!isDown) return;

        const dx = event.clientX - startX;
        if (!moved && Math.abs(dx) > DRAG_THRESHOLD) moved = true;

        if (moved) {
          list.scrollLeft = startScroll - dx;
          event.preventDefault();
        }
      };

      const onPointerUp = () => {
        if (!isDown) return;
        isDown = false;
        list.classList.remove('is-dragging');
        window.removeEventListener('pointermove', onPointerMove);
        window.removeEventListener('pointerup', onPointerUp);
        window.removeEventListener('pointercancel', onPointerUp);
      };

      list.addEventListener('pointerdown', (event) => {
        // Touch already scrolls natively; only intercept mouse drags.
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        isDown = true;
        moved = false;
        startX = event.clientX;
        startScroll = list.scrollLeft;
        list.classList.add('is-dragging');

        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', onPointerUp);
        window.addEventListener('pointercancel', onPointerUp);
      });

      // Cancel the click that follows a real drag so links don't navigate.
      // Uses the capture phase so it runs before the anchor's own handlers.
      list.addEventListener(
        'click',
        (event) => {
          if (!moved) return;
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        },
        true
      );

      // Also guard against the browser-native drag start on links/images.
      list.addEventListener('dragstart', (event) => event.preventDefault());
    };

    const initAll = (root = document) => {
      root.querySelectorAll(SELECTOR).forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    // Re-init sections added/edited in the theme editor.
    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["everyday-care-kits"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('everyday-care-kits')) return;

    const RESET_DELAY = 1500;
    const ERROR_DELAY = 5000;

    /** @type {Promise<any | null> | null} */
    let eventsModule = null;

    /** Loads Shopify's standard cart events through the theme import map; null when unavailable. */
    function loadEvents() {
      eventsModule ??= import('@shopify/events').catch(() => null);
      return eventsModule;
    }

    function routesRoot() {
      const root = window.Shopify?.routes?.root || '/';
      return root.endsWith('/') ? root : `${root}/`;
    }

    /**
     * One instance per section. All listeners are tied to one AbortController, so a theme
     * editor reload (new element) or reconnect never leaves duplicates behind.
     */
    class EverydayCareKits extends HTMLElement {
      /** @type {AbortController | null} */
      #controller = null;

      /** @type {ResizeObserver | null} */
      #resizeObserver = null;

      /** @type {number} */
      #frame = 0;

      /** @type {Set<number>} */
      #timers = new Set();

      connectedCallback() {
        this.#controller?.abort();
        this.#controller = new AbortController();
        const { signal } = this.#controller;
        const track = this.#track();

        this.addEventListener('submit', this.#onSubmit, { signal });
        this.addEventListener('shopify:block:select', this.#onBlockSelect, { signal });
        this.querySelector('[data-eck-prev]')?.addEventListener('click', () => this.#page(-1), { signal });
        this.querySelector('[data-eck-next]')?.addEventListener('click', () => this.#page(1), { signal });

        if (track) {
          track.addEventListener('scroll', this.#scheduleUpdate, { signal, passive: true });
          this.#resizeObserver = new ResizeObserver(this.#scheduleUpdate);
          this.#resizeObserver.observe(track);
        }

        this.#update();
      }

      disconnectedCallback() {
        this.#controller?.abort();
        this.#controller = null;
        this.#resizeObserver?.disconnect();
        this.#resizeObserver = null;
        window.cancelAnimationFrame(this.#frame);
        for (const id of this.#timers) window.clearTimeout(id);
        this.#timers.clear();
      }

      #track() {
        const track = this.querySelector('[data-eck-track]');
        return track instanceof HTMLElement ? track : null;
      }

      /**
       * @param {() => void} callback
       * @param {number} delay
       */
      #later(callback, delay) {
        const id = window.setTimeout(() => {
          this.#timers.delete(id);
          callback();
        }, delay);
        this.#timers.add(id);
      }

      #scheduleUpdate = () => {
        window.cancelAnimationFrame(this.#frame);
        this.#frame = window.requestAnimationFrame(() => this.#update());
      };

      /** Syncs the arrow states and whether the track has anything to scroll to. */
      #update() {
        const track = this.#track();
        if (!track) return;

        const max = track.scrollWidth - track.clientWidth;
        const position = Math.abs(track.scrollLeft);
        const prev = this.querySelector('[data-eck-prev]');
        const next = this.querySelector('[data-eck-next]');

        this.toggleAttribute('data-scrollable', max > 1);
        if (prev instanceof HTMLButtonElement) prev.disabled = position <= 1;
        if (next instanceof HTMLButtonElement) next.disabled = position >= max - 1;
      }

      /** @param {number} direction -1 for previous, 1 for next */
      #page(direction) {
        const track = this.#track();
        const card = track?.querySelector('.eck__item');
        if (!track || !(card instanceof HTMLElement)) return;

        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = card.offsetWidth + gap;
        const visible = Math.max(1, Math.floor((track.clientWidth + gap) / step));
        const rtl = getComputedStyle(track).direction === 'rtl';

        track.scrollBy({ left: direction * (rtl ? -1 : 1) * visible * step });
      }

      /** @param {string} message */
      #announce(message) {
        const status = this.querySelector('[data-eck-status]');
        if (!(status instanceof HTMLElement) || !message) return;
        status.textContent = '';
        this.#later(() => {
          status.textContent = message;
        }, 50);
      }

      /** Keeps the selected block visible inside the carousel while editing. */
      #onBlockSelect = (event) => {
        const item = event.target instanceof Element ? event.target.closest('.eck__item') : null;
        if (!item) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        item.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
      };

      /** @param {AbortSignal | undefined} signal */
      async #fetchCart(signal) {
        const response = await fetch(`${routesRoot()}cart.js`, {
          headers: { Accept: 'application/json' },
          signal,
        });
        if (!response.ok) throw new Error(this.dataset.labelError || '');
        return response.json();
      }

      /** @param {SubmitEvent} event */
      #onSubmit = async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-eck-form')) return;

        event.preventDefault();

        const button = form.querySelector('button[type="submit"]');
        const label = form.querySelector('[data-eck-label]');
        const errorEl = form.parentElement?.querySelector('[data-eck-error]');

        if (!(button instanceof HTMLButtonElement) || button.disabled || form.dataset.busy === 'true') return;

        /** @type {{ id: number, quantity: number }[]} */
        let items = [];
        try {
          items = JSON.parse(form.dataset.items || '[]');
        } catch {
          items = [];
        }
        if (!items.length || items.some((item) => !item.id)) return;

        const originalLabel = label?.textContent ?? '';
        const signal = this.#controller?.signal;
        const itemCount = items.reduce((total, item) => total + item.quantity, 0);

        form.dataset.busy = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (label) label.textContent = this.dataset.labelAdding || originalLabel;
        if (errorEl instanceof HTMLElement) errorEl.hidden = true;

        const sectionIds = [...document.querySelectorAll('cart-items-component')]
          .map((element) => (element instanceof HTMLElement ? element.dataset.sectionId : ''))
          .filter(Boolean);

        const events = await loadEvents();
        const CartLinesUpdateEvent = events?.CartLinesUpdateEvent;
        const deferred = CartLinesUpdateEvent ? CartLinesUpdateEvent.createPromise() : null;
        const detailBase = { source: 'everyday-care-kits', sourceId: this.id, itemCount };

        if (CartLinesUpdateEvent && deferred) {
          form.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
              promise: deferred.promise,
            })
          );
        }

        let succeeded = false;

        try {
          /** @type {Record<string, unknown>} */
          const body = { items };
          if (sectionIds.length) body.sections = sectionIds.join(',');

          const response = await fetch(`${routesRoot()}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(body),
            signal,
          });
          const result = await response.json().catch(() => ({}));

          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || this.dataset.labelError || '');
          }

          const cart = await this.#fetchCart(signal);

          if (CartLinesUpdateEvent && deferred) {
            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: { ...detailBase, items: cart.items, sections: result.sections, didError: false },
            });
            await deferred.promise.catch(() => {});
          }

          succeeded = true;
          if (label) label.textContent = this.dataset.labelAdded || originalLabel;
          this.#announce(this.dataset.labelAdded || '');
        } catch (error) {
          if (error instanceof DOMException && error.name === 'AbortError') {
            deferred?.reject(error);
            return;
          }

          const message = (error instanceof Error && error.message) || this.dataset.labelError || '';

          if (CartLinesUpdateEvent && deferred) {
            try {
              const cart = await this.#fetchCart(signal);
              deferred.resolve({
                cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                detail: { ...detailBase, items: cart.items, didError: true },
              });
            } catch (cartError) {
              deferred.reject(cartError);
            }
            if (events.CartErrorEvent) {
              form.dispatchEvent(new events.CartErrorEvent({ error: message, code: 'INVALID' }));
            }
          }

          if (label) label.textContent = originalLabel;
          if (errorEl instanceof HTMLElement) {
            errorEl.textContent = message;
            errorEl.hidden = false;
            this.#later(() => {
              errorEl.hidden = true;
              errorEl.textContent = '';
            }, ERROR_DELAY);
          }
          this.#announce(message);
        } finally {
          button.removeAttribute('aria-busy');
          const restore = () => {
            if (label) label.textContent = originalLabel;
            button.disabled = false;
            delete form.dataset.busy;
          };
          if (succeeded) this.#later(restore, RESET_DELAY);
          else restore();
        }
      };
    }

    customElements.define('everyday-care-kits', EverydayCareKits);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnp-bestsellers-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fnp-bestseller-filters')) {
    customElements.define(
      'fnp-bestseller-filters',
      class FnpBestsellerFilters extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.items = Array.from(this.querySelectorAll('[data-bestsellers-item]'));
          this.empty = this.querySelector('[data-bestsellers-empty]');
          this.grid = this.querySelector('[data-bestsellers-grid]');
          this.filterButtons = Array.from(this.querySelectorAll('[data-filter-tag]'));
          this.clearButton = this.querySelector('[data-clear-filters]');
          this.clearLabel = this.clearButton?.querySelector('[data-clear-label]');
          this.activeTag = '';
          this.sortValue = 'featured';

          this.filterButtons.forEach((button) => {
            button.addEventListener('click', () => {
              this.activeTag = button.dataset.filterTag;
              this.apply();
            });
          });

          this.clearButton?.addEventListener('click', () => {
            if (!this.activeTag) return;
            this.activeTag = '';
            this.apply();
          });

          this.querySelectorAll('[data-sort-value]').forEach((option) => {
            option.addEventListener('click', (event) => {
              event.preventDefault();
              this.sortValue = option.dataset.sortValue;
              const details = option.closest('details');
              if (details) details.open = false;
              this.apply();
            });
          });

          document.addEventListener('click', (event) => {
            this.querySelectorAll('details[open]').forEach((details) => {
              if (!details.contains(event.target)) details.open = false;
            });
          });
        }

        syncFilterUI() {
          this.filterButtons.forEach((button) => {
            const isActive = button.dataset.filterTag === this.activeTag;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          if (this.clearLabel && this.clearButton) {
            this.clearLabel.textContent = this.activeTag
              ? this.clearButton.dataset.labelActive
              : this.clearButton.dataset.labelIdle;
          }
        }

        apply() {
          this.syncFilterUI();
          const visible = [];

          this.items.forEach((item) => {
            const tags = (item.dataset.tags || '').split(',').filter(Boolean);
            const match = !this.activeTag || tags.includes(this.activeTag);
            const wrap = item.parentElement !== this.grid ? item.parentElement : item;
            wrap.hidden = !match;
            if (match) visible.push({ wrap, item });
          });

          visible.sort((a, b) => {
            switch (this.sortValue) {
              case 'price-asc':
                return Number(a.item.dataset.price) - Number(b.item.dataset.price);
              case 'price-desc':
                return Number(b.item.dataset.price) - Number(a.item.dataset.price);
              case 'title-asc':
                return a.item.dataset.title.localeCompare(b.item.dataset.title);
              case 'newest':
                return Number(b.item.dataset.date) - Number(a.item.dataset.date);
              default:
                return Number(a.item.dataset.index) - Number(b.item.dataset.index);
            }
          });

          visible.forEach(({ wrap }) => this.grid.appendChild(wrap));

          const offerCard = this.grid.querySelector('[data-fp2-col-offer]');
          if (offerCard) this.grid.appendChild(offerCard);

          if (this.empty) this.empty.hidden = visible.length > 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnp-compare-shades"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fnp-compare-shades')) {
    customElements.define(
      'fnp-compare-shades',
      class FnpCompareShades extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.select(tab));
            tab.addEventListener('keydown', (event) => this.onKey(event, tab));
          });
        }

        select(tab) {
          const name = this.querySelector('[data-compare-name]');
          this.tabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
            item.tabIndex = selected ? 0 : -1;
            if (selected && name) name.textContent = item.dataset.shadeName || '';
          });

          this.panels.forEach((panel) => {
            panel.hidden = panel.id !== tab.getAttribute('aria-controls');
          });
        }

        onKey(event, tab) {
          const move = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: 1, ArrowUp: -1 };
          const delta = move[event.key];
          if (!delta) return;

          event.preventDefault();
          const index = this.tabs.indexOf(tab);
          const next = this.tabs[(index + delta + this.tabs.length) % this.tabs.length];
          next.focus();
          this.select(next);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-education-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-education-tabs')) {
    /**
     * Accessible tabs for the product education section.
     * Each instance owns its own listeners, so Theme Editor re-renders replace it cleanly.
     */
    class ProductEducationTabs extends HTMLElement {
      /** @type {AbortController | undefined} */
      #abortController;

      connectedCallback() {
        this.#abortController?.abort();
        this.#abortController = new AbortController();
        const { signal } = this.#abortController;

        const tablist = this.tablist;
        if (!tablist || this.tabs.length === 0) return;

        tablist.addEventListener('click', this.handleClick, { signal });
        tablist.addEventListener('keydown', this.handleKeydown, { signal });
        this.addEventListener('shopify:block:select', this.handleBlockSelect, { signal });

        const initialTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') ?? this.tabs[0];
        this.select(initialTab, { behavior: 'instant' });
      }

      disconnectedCallback() {
        this.#abortController?.abort();
        this.#abortController = undefined;
      }

      /** @returns {HTMLElement | null} */
      get tablist() {
        return this.querySelector('[role="tablist"]');
      }

      /** @returns {HTMLButtonElement[]} */
      get tabs() {
        return Array.from(this.querySelectorAll('[role="tab"]'));
      }

      /**
       * @param {HTMLElement} tab
       * @returns {HTMLElement | null}
       */
      getPanel(tab) {
        const panelId = tab.getAttribute('aria-controls');
        return panelId ? this.querySelector(`#${CSS.escape(panelId)}`) : null;
      }

      /** @param {MouseEvent} event */
      handleClick = (event) => {
        if (!(event.target instanceof Element)) return;
        const tab = event.target.closest('[role="tab"]');
        if (!(tab instanceof HTMLElement) || !this.contains(tab)) return;

        this.select(tab);
      };

      /** @param {KeyboardEvent} event */
      handleKeydown = (event) => {
        if (!(event.target instanceof Element)) return;
        const current = event.target.closest('[role="tab"]');
        const tabs = this.tabs;
        const index = tabs.indexOf(/** @type {HTMLButtonElement} */ (current));
        if (index === -1) return;

        const isRtl = getComputedStyle(this).direction === 'rtl';
        const forward = isRtl ? 'ArrowLeft' : 'ArrowRight';
        const backward = isRtl ? 'ArrowRight' : 'ArrowLeft';

        let nextIndex;
        switch (event.key) {
          case forward:
            nextIndex = (index + 1) % tabs.length;
            break;
          case backward:
            nextIndex = (index - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        const nextTab = tabs[nextIndex];
        if (!nextTab) return;

        nextTab.focus({ preventScroll: true });
        this.select(nextTab);
      };

      /** @param {Event} event */
      handleBlockSelect = (event) => {
        if (!(event.target instanceof Element)) return;
        const tab = event.target.closest('[role="tab"]');
        if (!(tab instanceof HTMLElement) || !this.contains(tab)) return;

        this.select(tab, { behavior: 'instant' });
      };

      /**
       * Activates a tab, shows its panel, and stops media in every other panel.
       * @param {HTMLElement} activeTab
       * @param {object} [options]
       * @param {ScrollBehavior} [options.behavior]
       */
      select(activeTab, { behavior } = {}) {
        for (const tab of this.tabs) {
          const isActive = tab === activeTab;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;

          const panel = this.getPanel(tab);
          if (!panel) continue;

          if (isActive) {
            panel.hidden = false;
            panel.inert = false;
            this.#startMedia(panel);
          } else {
            this.#stopMedia(panel);
            panel.hidden = true;
            panel.inert = true;
          }
        }

        this.#scrollTabIntoView(activeTab, behavior);
      }

      /** @param {HTMLElement} panel */
      #startMedia(panel) {
        for (const iframe of panel.querySelectorAll('iframe[data-src]')) {
          const src = iframe.getAttribute('data-src');
          if (src && iframe.getAttribute('src') !== src) iframe.setAttribute('src', src);
        }

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        for (const video of panel.querySelectorAll('[data-autoplay] video')) {
          if (!(video instanceof HTMLVideoElement) || reduceMotion) continue;
          video.muted = true;
          video.play().catch(() => {});
        }
      }

      /** @param {HTMLElement} panel */
      #stopMedia(panel) {
        for (const video of panel.querySelectorAll('video')) {
          if (video instanceof HTMLVideoElement && !video.paused) video.pause();
        }

        // Unloading the player is the only reliable way to stop third-party embeds.
        for (const iframe of panel.querySelectorAll('iframe[data-src]')) {
          if (iframe.hasAttribute('src')) iframe.removeAttribute('src');
        }
      }

      /**
       * Scrolls only the tab row (never the page) so the selected tab is fully visible.
       * @param {HTMLElement} tab
       * @param {ScrollBehavior} [behavior]
       */
      #scrollTabIntoView(tab, behavior) {
        const tablist = this.tablist;
        if (!tablist || tablist.scrollWidth <= tablist.clientWidth) return;

        const listRect = tablist.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const style = getComputedStyle(tablist);
        const visibleLeft = listRect.left + (parseFloat(style.paddingLeft) || 0);
        const visibleRight = listRect.right - (parseFloat(style.paddingRight) || 0);

        let delta = 0;
        if (tabRect.left < visibleLeft) {
          delta = tabRect.left - visibleLeft;
        } else if (tabRect.right > visibleRight) {
          delta = tabRect.right - visibleRight;
        }
        if (delta === 0) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        tablist.scrollBy({ left: delta, behavior: behavior ?? (reduceMotion ? 'instant' : 'smooth') });
      }
    }

    customElements.define('product-education-tabs', ProductEducationTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-you-can-see"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('results-you-can-see')) return;

    const RESET_DELAY = 1500;
    const ERROR_DELAY = 5000;

    /** @type {Promise<any | null> | null} */
    let eventsModule = null;

    /** Loads Shopify's standard cart events through the theme import map; null when unavailable. */
    function loadEvents() {
      eventsModule ??= import('@shopify/events').catch(() => null);
      return eventsModule;
    }

    function routesRoot() {
      const root = window.Shopify?.routes?.root || '/';
      return root.endsWith('/') ? root : `${root}/`;
    }

    /**
     * One instance per section. Listeners are delegated to the element itself, so
     * theme-editor reloads replace the element and its listeners together.
     */
    class ResultsYouCanSee extends HTMLElement {
      /** @type {AbortController | null} */
      #controller = null;

      /** @type {Set<number>} */
      #timers = new Set();

      connectedCallback() {
        this.#controller?.abort();
        this.#controller = new AbortController();
        const { signal } = this.#controller;

        this.addEventListener('submit', this.#onSubmit, { signal });
        this.addEventListener('shopify:block:select', this.#onBlockSelect, { signal });
      }

      disconnectedCallback() {
        this.#controller?.abort();
        this.#controller = null;
        for (const id of this.#timers) window.clearTimeout(id);
        this.#timers.clear();
      }

      /**
       * @param {() => void} callback
       * @param {number} delay
       */
      #later(callback, delay) {
        const id = window.setTimeout(() => {
          this.#timers.delete(id);
          callback();
        }, delay);
        this.#timers.add(id);
      }

      /** @param {string} message */
      #announce(message) {
        const status = this.querySelector('[data-results-status]');
        if (!(status instanceof HTMLElement) || !message) return;
        status.textContent = '';
        this.#later(() => {
          status.textContent = message;
        }, 50);
      }

      /** Keeps the selected block visible inside the mobile carousel while editing. */
      #onBlockSelect = (event) => {
        const item = event.target instanceof Element ? event.target.closest('.results-see__item') : null;
        if (!item) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        item.scrollIntoView({ block: 'nearest', inline: 'start', behavior: reduce ? 'auto' : 'smooth' });
      };

      /** @param {AbortSignal | undefined} signal */
      async #fetchCart(signal) {
        const response = await fetch(`${routesRoot()}cart.js`, {
          headers: { Accept: 'application/json' },
          signal,
        });
        if (!response.ok) throw new Error(this.dataset.labelError || '');
        return response.json();
      }

      /** @param {SubmitEvent} event */
      #onSubmit = async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-results-form')) return;

        event.preventDefault();

        const button = form.querySelector('button[type="submit"]');
        const label = form.querySelector('[data-results-label]');
        const errorEl = form.querySelector('[data-results-error]');
        const variantId = Number(form.dataset.variantId);

        if (!(button instanceof HTMLButtonElement) || button.disabled || form.dataset.busy === 'true') return;
        if (!variantId) return;

        const originalLabel = label?.textContent ?? '';
        const signal = this.#controller?.signal;

        form.dataset.busy = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (label) label.textContent = this.dataset.labelAdding || originalLabel;
        if (errorEl instanceof HTMLElement) errorEl.hidden = true;

        // Ask for the theme's cart sections so the drawer can re-render in place.
        const sectionIds = [...document.querySelectorAll('cart-items-component')]
          .map((element) => (element instanceof HTMLElement ? element.dataset.sectionId : ''))
          .filter(Boolean);

        const events = await loadEvents();
        const CartLinesUpdateEvent = events?.CartLinesUpdateEvent;
        const deferred = CartLinesUpdateEvent ? CartLinesUpdateEvent.createPromise() : null;
        const detailBase = {
          source: 'results-you-can-see',
          sourceId: this.dataset.resultsSection,
          itemCount: 1,
          productId: form.dataset.productId,
        };

        if (CartLinesUpdateEvent && deferred) {
          form.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(variantId), quantity: 1 }],
              promise: deferred.promise,
            })
          );
        }

        let succeeded = false;

        try {
          /** @type {Record<string, unknown>} */
          const body = { items: [{ id: variantId, quantity: 1 }] };
          if (sectionIds.length) body.sections = sectionIds.join(',');

          const response = await fetch(`${routesRoot()}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(body),
            signal,
          });
          const result = await response.json().catch(() => ({}));

          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || this.dataset.labelError || '');
          }

          const cart = await this.#fetchCart(signal);

          if (CartLinesUpdateEvent && deferred) {
            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: { ...detailBase, items: cart.items, sections: result.sections, didError: false },
            });
            await deferred.promise.catch(() => {});
          }

          // Generic events for themes and apps that listen for them.
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));

          succeeded = true;
          if (label) label.textContent = this.dataset.labelAdded || originalLabel;
          this.#announce(this.dataset.labelAdded || '');
        } catch (error) {
          if (error instanceof DOMException && error.name === 'AbortError') {
            deferred?.reject(error);
            return;
          }

          const message = (error instanceof Error && error.message) || this.dataset.labelError || '';

          if (CartLinesUpdateEvent && deferred) {
            try {
              const cart = await this.#fetchCart(signal);
              deferred.resolve({
                cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                detail: { ...detailBase, items: cart.items, didError: true },
              });
            } catch (cartError) {
              deferred.reject(cartError);
            }
            if (events.CartErrorEvent) {
              form.dispatchEvent(new events.CartErrorEvent({ error: message, code: 'INVALID' }));
            }
          }

          if (label) label.textContent = originalLabel;
          if (errorEl instanceof HTMLElement) {
            errorEl.textContent = message;
            errorEl.hidden = false;
            this.#later(() => {
              errorEl.hidden = true;
              errorEl.textContent = '';
            }, ERROR_DELAY);
          }
          this.#announce(message);
        } finally {
          button.removeAttribute('aria-busy');
          const restore = () => {
            if (label) label.textContent = originalLabel;
            button.disabled = false;
            delete form.dataset.busy;
          };
          if (succeeded) this.#later(restore, RESET_DELAY);
          else restore();
        }
      };
    }

    customElements.define('results-you-can-see', ResultsYouCanSee);
  })();

  } catch(e) { console.error(e); }
})();
})();
